import IdleJs from 'idle-js';
import React, { useEffect } from 'react';
import { Admin, Resource, defaultDarkTheme, CustomRoutes } from 'react-admin';
import { Helmet } from 'react-helmet';
import { Route } from 'react-router-dom';
import 'react-big-calendar/lib/css/react-big-calendar.css'
import './App.css';
import { MyLayout } from './layout';
import { authProvider, dataProvider } from './providers';
import {
  ListSchedule,
  EditSchedule,
  CreateSchedule,
  ListCheckpoint,
  EditCheckpoint,
  ListRoute,
  EditRoute,
  CreateRoute,
  CreateCheckpoint,
  EditUser,
  ListUser,
  CreateUser,
  ListReport,
  ListLogs,
  LogDetail,
  ListOverview,
  PatrolView,
} from './resources';
import palette from './theme/palette';
import { ForgotPassword, Login, Profile } from './pages';

const customDarkTheme = {
  ...defaultDarkTheme,
  palette: {
    ...defaultDarkTheme.palette,
    background: palette.background,
    primary: palette.primary,
  },
  typography: {
    fontFamily: '"Lato", sans-serif', // Add Lato as the default font
  },
};

const App = () => {
  const idle = new IdleJs({
    idle: 30 * 60 * 1000, // idle time in ms
    events: ['mousemove', 'keydown', 'mousedown', 'touchstart'],
    onIdle: () => {
      window.location.reload();
    },
  });
  
  useEffect(() => {
    idle.start();
  }, []);

  return (
    <>
      <Helmet>
        <title>Virtual Patrol</title>
      </Helmet>
      <Admin
        theme={customDarkTheme}
        authProvider={authProvider}
        dataProvider={dataProvider}
        loginPage={Login}
        layout={MyLayout}
      >
        <Resource name="overview" list={ListOverview} />
        <Resource name="logs" list={ListLogs} />
        <Resource name="reports" list={ListReport} />
        <Resource
          name="cognitoUsers"
          list={ListUser}
          edit={EditUser}
          create={CreateUser}
          options={{
            label: 'Users',
          }}
        />
        <Resource name="cognitoGroups" options={{ label: 'Groups' }} />
        <Resource
          name="checkpoints"
          list={ListCheckpoint}
          edit={EditCheckpoint}
          create={CreateCheckpoint}
        />
        <Resource
          name="routes"
          list={ListRoute}
          edit={EditRoute}
          create={CreateRoute}
        />
        <Resource
          name="schedules"
          list={ListSchedule}
          edit={EditSchedule}
          create={CreateSchedule}
        />
        <CustomRoutes>
          <Route path="/profile" element={<Profile />} />
          <Route path="/logs/:id" element={<LogDetail />} />
        </CustomRoutes>
        <CustomRoutes noLayout>
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/patrol-view" element={<PatrolView />} />
        </CustomRoutes>
      </Admin>
    </>
  );
}

export default App;
